// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import React, { useCallback } from 'react'
import OrderableListOption from './OrderableListOption';
import { Box } from '@material-ui/core';
import PropTypes, { object } from 'prop-types';

function OrderableList(props) {
  const {
    options,
    setOptions,
    handleOptions,
    handleAddOptionsOnKeyPress,
    handleDeleteOption,
    classes,
  } = props

  const moveCard = useCallback((dragIndex, hoverIndex) => {
    setOptions((prevOptions) => {
      const newOptions = [...prevOptions];
      newOptions.splice(dragIndex, 1);
      newOptions?.splice(hoverIndex, 0, prevOptions[dragIndex]);
      return newOptions;
    });
  }, []);

  const renderOption = useCallback((option, index) => {
    return (
      <OrderableListOption
        key={option.ordinal}
        index={index}
        ordinal={option.ordinal}
        moveCard={moveCard}
        value={option.value}
        handleDeleteOption={handleDeleteOption}
        handleAddOptionsOnKeyPress={handleAddOptionsOnKeyPress}
        classes={classes}
        showClearIcon={options.length !== 1}
        setOptions={setOptions}
        handleOptions={handleOptions}
      />
    );
  }, [options]);

  return (
    <div>
      <Box className={""}>{options?.map((option, i) => renderOption(option, i))}</Box>
    </div>
  )
}

OrderableList.propTypes = {
  options: PropTypes.arrayOf(object),
  setOptions: PropTypes.func,
  handleOptions: PropTypes.func,
  handleAddOptionsOnKeyPress: PropTypes.func,
  handleDeleteOption: PropTypes.func,
  classes: PropTypes.object,
  handleOptionBlur: PropTypes.func,
  optionEmptyError: PropTypes.bool,
}

export default OrderableList;
